import { schema } from "normalizr";
import { Inventory } from "records/item";

export const InventorySchema = new schema.Entity(
    "inventory",
    {},
    {
        idAttribute: (value) => `${value.sku_id}_${value.for_date}`,
    }
);

(InventorySchema as any).record = Inventory;
